import { useMemo } from 'react';
import { AttributeRenderer as CommonAttributeRenderer } from '@/features/c-form/AttributeRenderer';
import { buildAdaptedUpdateFn, buildFilteredStoreValues, toRendererAttributes } from '@/features/section-attribute';
import type { DeviceDetailAttribute } from './-query';
import { useDeviceDetailFormStore } from './-store/store';
interface Props {
  attributes: DeviceDetailAttribute[];
  sectionKey: string;
  displayOrder: number;
}
export function DeviceDetailAttributeRenderer({
  attributes,
  sectionKey,
  displayOrder
}: Props) {
  const {
    actions,
    values
  } = useDeviceDetailFormStore();
  const storeValues = useMemo(() => buildFilteredStoreValues(values.sections ?? [], sectionKey, displayOrder), [values.sections, sectionKey, displayOrder]);
  const updateSectionAttribute = useMemo(() => buildAdaptedUpdateFn(actions.updateSectionAttribute, displayOrder), [actions.updateSectionAttribute, displayOrder]);
  const rendererAttributes = useMemo(() => toRendererAttributes(attributes.map(attr => ({
    ...attr,
    name: attr.name ?? attr.attributeKey
  }))), [attributes]);
  return <CommonAttributeRenderer attributes={rendererAttributes} sectionKey={sectionKey} updateSectionAttribute={updateSectionAttribute} storeValues={storeValues} />;
}